<template>
    <v-container id="accommodation-consideration" fluid>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-hand-heart</v-icon>Accommodation Consideration
            <br>
            To determine how we can best meet your special accommodation needs, it is helpful to
            understand your particular needs. Please provide additional information in the areas below
            if you have special accommodation needs.
        </v-card-subtitle>
        <!-- Super Single / Single Room Request Section -->   
        <v-card-subtitle class="px-0" v-if="showSuperSingleRequestView == true">
            <strong>Super Single Room / Single Room</strong>   
            <br />Students will be placed into double rooms. If you wish Single Room accommodation, please select one of the following:             
        </v-card-subtitle>
        <v-card elevation="0" outlined v-if="showSuperSingleRequestView == true">
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <strong>Super Single Room</strong> - Individual space, with double bed with storage underneath, bedside table, wardrobe closet, desk and desk chair, love seat and ottoman, mini fridge and microwave combination. Shared bathroom with 3 other residents.  
                        <br /><br />
                        Additional room fee applies.
                        <br /><br />
                        Limited availability.
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox v-model="item.requestSuperSingle" true-value="yes" false-value="no" label="I am requesting a Super Single"></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card><br />
        <v-card elevation="0" outlined v-if="showSuperSingleRequestView == true">
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <strong>Single Room</strong> - Double room with no roommate, two twin beds, two desks and desk chairs, two wardrobe closets. Shared bathroom with up to 6 residents.
                        <br /><br />
                        Additional room fee applies.
                        <br /><br />
                        Limited availability.
                    </v-col>
                    <v-col cols="12">
                        <v-alert :color="infoColor" icon="mdi-information" outlined>
                            Please provide medical documentation if you are applying for a single room. Submit to residence@kings.uwo.ca
                        </v-alert> 
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox v-model="item.requestSingleRoom" true-value="yes" false-value="no" label="I am requesting a Single Room"></v-checkbox>
                    </v-col>              
                </v-row>
            </v-card-text>
        </v-card><br />
        <!-- End Single Room Request Section -->   
        <v-row>
            <v-col cols="12">
                <v-textarea v-model="item.specialAccommodationConsideration" auto-grow
                    hint="For instance, is a main floor room for accessibility reasons, a room close to a washroom for medical reasons, a quieter area for sleep issues, or a single room for a particular reason. Please provide any information you believe to be relevant to your request."
                    label="What type of accommodation consideration are you requesting and what needs motivate this request? (Optional)"
                    outlined persistent-hint :rules="specialAccommodationConsiderationRules">
                </v-textarea>
            </v-col>
            <v-col cols="12">
                <v-select v-model="item.specialAccommodationBasis" dense :items="specialAccommodationBasisItems"
                    label="Is your request based on a significant impairment, medical condition, physical or personal challenge? (Optional)"
                    outlined :rules="specialAccommodationBasisRules">
                </v-select>
            </v-col>
            <v-col cols="12">
                <v-textarea v-model="item.specialAccommodationDescription" auto-grow
                    label="Please describe the current impact and/or limitations imposed by your condition or challenge (Optional)"
                    outlined persistent-hint :rules="specialAccommodationDescriptionRules">
                </v-textarea>
            </v-col>
            <v-card-subtitle class="pt-0 px-0" v-if="showSuperSingleRequestView == false">
                Single Room Request<br>
                In order to evaluate how we can best meet your special accommodation needs, we require additional information.  Please be advised that you may be asked to provide medical documentation to support your request, if your request is based on medical or mental health concerns.<br>
                <b>Please note: there is an additional $1800 fee for single room accommodation</b>.<br>
                While we welcome single room requests after the guarantee deadline, space limitations may limit single room assignments after that time.                        
            </v-card-subtitle>
            <v-col class="pt-0" cols="12" v-if="showSuperSingleRequestView == false">
                <v-checkbox v-model="item.singleRoomRequestReason" true-value="Medical concerns" false-value="" dense hide-details
                    label="Medical concerns (ie: mobility, specific washroom facility needs, mental health, serious allergies, etc)"
                >
                </v-checkbox> 
                <v-checkbox v-model="item.singleRoomRequestReason" true-value="COVID concern" false-value="" dense hide-details
                    label="COVID concern"
                >
                </v-checkbox> 
                <v-checkbox v-model="item.singleRoomRequestReason" true-value="Other" false-value="" dense hide-details
                    label="Other"
                >
                </v-checkbox> 
            </v-col>
            <v-col class="pt-2" cols="12" v-if="showSuperSingleRequestView == false">
                <v-textarea v-model="item.singleRoomRequestAdditionalInformation" auto-grow hide-details
                    label="Special Room Request Additional Information" outlined>
                </v-textarea>
            </v-col>
        </v-row>
        <v-card-subtitle class="pt-0 px-0">
            <v-icon :color="kingsGold" left>mdi-signature</v-icon>Special Accommodations Terms
            <br>
            I understand the Residence Office may, in confidence, share this information to consult with
            Accessibility Services and /or Student Health Services to fully assess this
            request. I give the Residence Office permission to do this. I give the Residence Office
            permission to confirm with Accessibility Services that I have contacted
            that office to arrange support services for the academic year.
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-checkbox v-model="item.specialAccommodationAgreeToTerms" false-value="0"
                    label="I have read and agree to the Special Accommodations Terms" true-value="1">
                </v-checkbox>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'applicant-personal-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            specialAccommodationBasisItems: [{
                    text: 'Yes',
                    value: 'Yes'
                },
                {
                    text: 'No',
                    value: 'No'
                }
            ],
            showSuperSingleRequestView: true
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        }
    },
    methods: {
        checkSubmissionDate(){
            const that = this;

            let createdTimestamp = that.item.createdTimestamp;
            let cutoffDate = 0;

            //Update Nov 7, 2025
            //If submitted before Nov 14 00:00 AM (1763096401), show older Single Room request, else show the new Single Room / Super Single request view (production)
            
            if(location.hostname == 'mykings.ca'){
                cutoffDate = 1763096401; //2025 Nov 14 00:00:01
            }else {
                cutoffDate = 1762542000; //2025 Nov 07 14:00:00
            }

            if(parseInt(createdTimestamp) < parseInt(cutoffDate)){
                that.showSuperSingleRequestView = false;
            }else {
                that.showSuperSingleRequestView = true;
            }
            
        },
    },
    beforeUpdate(){
        this.checkSubmissionDate();
    }
}
</script>

<style scoped>
.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}

.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>